export const PRODUCTS_BY_TYPE_LOADING = 'REDUX_SAGA_PRODUCTS_BY_TYPE_LOADING';
export const PRODUCTS_DATA_SUCCESS = 'REDUX_SAGA_PRODUCTS_DATA_SUCCESS';
export const PRODUCTS_DATA_ERROR = 'REDUX_SAGA_PRODUCTS_DATA_ERROR';

export const actionGetProductsByTypeAndDisplayAreas = (dispatch, type, displayAreaNo) => {
    dispatch({ type: PRODUCTS_BY_TYPE_LOADING, productType: type, displayAreaNo })
};